// @ts-ignore — vanilla tracking helpers from user-login (no React in this subpath)
import { tracking } from '@finder/user-login/lib/tracking';

import { on, qs } from '../../core/dom';
import type { NavModuleInit } from '../../core/types';

const init: NavModuleInit = ({ root, bus, state }) => {
  root.classList.remove('no-js');
  root.dataset.gnState = 'ready';

  const initiallyExpanded = !!qs('[data-gn-region="side-nav"].gn-side-nav--expanded', document);
  document.documentElement.style.setProperty(
    '--main-right-content-padding',
    initiallyExpanded ? '276px' : '64px',
  );

  const onClick = (e: MouseEvent) => {
    if (!(e.target instanceof Element)) return;
    const target = e.target.closest<HTMLElement>('[data-track]');
    if (target) {
      bus.emit('analytics:click', {
        label: target.getAttribute('data-track') ?? target.textContent?.trim() ?? '',
      });
    }
  };
  const offClick = on(root, 'click', onClick, true);

  const offTracking = bus.on('analytics:click', (detail) => {
    try {
      tracking.buttonClick({
        controlText: detail.label,
        target: 'navigation',
      });
    } catch {}
  });

  document.documentElement.dataset.gnCountry = state.country;

  return {
    destroy: () => {
      offClick();
      offTracking();
    },
  };
};

export default init;
